import { sharedHeaders } from "../utils/constants"

const cancelDraft = {
  "type": "endpoint",
  "method": "patch",
  "title": "Cancel Draft",
  "path": "/v1/draft/{draft_id}/cancel",
  "description": "Cancel a pending purchase draft (only if not created with hosted payment)",
  "request": {
    "headers": [
      ...sharedHeaders
    ],
    "pathParams": [
      {
        "key": "draft_id",
        "required": true,
        "type": "string",
        "description": "ID of the draft purchase to cancel",
        "example": "lX8RkQmK49iPVWRt9gdc"
      }
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response"
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "CancelDraftParams": {
        "type": "object",
        "properties": {
          "draft_id": {
            "type": "string",
            "description": "ID of the draft purchase to cancel",
            "example": "lX8RkQmK49iPVWRt9gdc"
          }
        },
        "required": [
          "draft_id"
        ]
      }
    }
  }
}

export { cancelDraft }
